<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Dettaglio news #' + this.$route.params.id : 'Nuova news')">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio || this.$route.params.id == null)">                        
                        <b-row class="my-1">
                            <b-col sm="3"><label for="nominativo">Titolo:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.nominativo" id="nominativo" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="descrizione">Descrizione:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="descrizione" v-model="news.descrizione" :rows="2"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="indirizzo">Indirizzo:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="indirizzo" v-model="news.indirizzo" :rows="2"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="sitoweb">Sito web:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.sitoweb" id="sitoweb" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="facebook">Facebook:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.facebook" id="facebook" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="coordinate">Coordinate:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.coordinate" id="coordinate" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="telefono">Telefono:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.telefono" id="telefono" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="gruppowa">Link gruppo WhatsApp:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.gruppowa" id="gruppowa" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="email">Email:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.email" id="email" type="email"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.datainizio" id="datainizio" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.datafine" id="datafine" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="categoria">Categoria:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="news.id_categoria" :options="options_categorie" id="categoria">
                                    <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="null" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="giorniprima">Visibilità giorni prima:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.giorniprima" id="giorniprima" type="number"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datanotifica">Data invio notifica:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.datanotifica" id="datanotifica" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flagnotifica">Notifica inviata:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.flagNotifica" id="flagnotifica" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="visibilità">Visibilità:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="news.visibilita" :options="options_visibilità" id="visibilità">
                                    <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="null" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>  
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flagatt">Attivo:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="news.flagsta" :options="options_attivo" id="flagsta">

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="note">Note:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="note" v-model="news.note" :rows="3"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="my-1" v-if="news.id != null">
                            <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.datains" id="datains" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>                                
                        <b-row class="my-1" v-if="news.id != null">
                            <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="news.uteins" id="uteins" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>   
                        <b-row class="my-3">
                            <b-col sm="5" offset-sm="3" v-show="news.id != null">
                                <b-button block size="md" variant="outline-secondary" v-on:click="voti()">
                                    Voti
                                </b-button>
                            </b-col>
                            <b-col sm="4" v-show="news.id != null">
                                <b-button block size="md" variant="outline-secondary" v-on:click="allegatiImmagini()">
                                    Allegati e immagini
                                </b-button>
                            </b-col>
                        </b-row> 
                        <b-row class="my-3">
                            <b-col sm="5" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="news.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>                                    
                        </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>

import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'

import {
    Visibilità,
    Categoria
} from '../classes.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {
            
            namespace: NAMESPACE,
            news: {
                id: this.$route.params.id || null,
                id_categoria: null,
                nominativo: '',
                descrizione: '',
                indirizzo: '',
                sitoweb: '',
                facebook: '',
                coordinate: '',
                telefono: '',
                email: '',
                datainizio: '',
                datafine: '',
                flagsta: 'S',
                datanotifica: '',
                gruppowa: '',
                note: '',
                flagnotifica: 'N',
                giorniprima: 365,
                datains: null,
                uteins: '',
                visibilita: null
            },                    
            error: '',
            options_visibilità: [],
            options_categorie: [],
            flagTipo: '',
            options_attivo: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],   
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0                      
        };
    },
    computed: {

        flagNotifica: {
            // getter
            get: function () {
                return this.getFlagNotifica();
            }
        }

    },
    methods: { 
        getFlagNotifica() {

            return (this.news.flagnotifica == 'N' ? 'No' : 'Sì');
        },         
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        allegatiImmagini() {

            this.$router.push({
                path: `/app/allegati/id/${this.news.id}/tipo/${this.flagTipo}`
            });

        },
        voti() {

            this.$router.push({
                path: `/app/voti/id/${this.news.id}/tipo/${this.flagTipo}`
            });

        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.sociModal.currentPage = 1;
        },
        insert() {
            var appdettaglio = this;
            
            if (this.news.nominativo == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo titolo vuoto!";

            } else if (this.news.descrizione == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo descrizione vuoto!";   

            } else if (this.news.id_categoria == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Categoria non selezionata!";

            } else if (this.news.datainizio == "" || this.news.datainizio == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data inizio vuota!";

            } else if (this.news.datafine == "" || this.news.datafine == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data fine vuota!";

            } else if (this.news.datafine < this.news.datainizio) { //sono stringhe yyyy-mm-dd
                appdettaglio.showerror = true;
                appdettaglio.error = "Data inizio maggiore di data fine!";   
            
            } else if ((this.news.visibilita || '') == '') {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Visibilità non selezionata!";

            } else if (this.news.giorniprima < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Visibilità giorni prima < 0!";

            } else {
                
                var json = JSON.stringify(this.news);                

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/news', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    res[0].datanotifica = (res[0].datanotifica == "0000-00-00 00:00:00" ? "" : moment(res[0].datanotifica, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"));
                                    this.news = res[0];
                                    this.showerror = false;
                                    this.showdettaglio = true; //anche se non dovrebbe servire                                 
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/dettaglionews/' + this.news.id);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }

                            } else {
                                throw new Error(response.data.message);
                            }

                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            }

        }
    },
    created: function () {

        

        if(!ctrlVismenu("N")){
            this.$router.replace('/accessdenied');
            return;
        }


        var id = this.news.id; //se è la prima volta si prova a prendere da getid 
        var token = localStorage.getItem('token');

        if (id != null) {
            
            var appdettaglio = this;

            this.axios.get(NAMESPACE + 'rest/news/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                res[0].datanotifica = (res[0].datanotifica == "0000-00-00 00:00:00" ? "" : moment(res[0].datanotifica, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"));                                   
                                appdettaglio.news = res[0];                                
                                appdettaglio.showdettaglio = true;


                            } else {
                                throw new Error("Errore dati non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }

        const tipoPagina = 'News';

        //recupero il valore del flag del tipo della categoria
        var cat = new Categoria();
        var tipi = cat.getListaTipi();
        var keys = Object.keys(tipi);
        var flagTipo = "";
        for (i = 0; i < keys.length; i++) {
            if (tipi[keys[i]] == tipoPagina) {
                flagTipo = keys[i];
            }
        }

        this.flagTipo = flagTipo;

        //chiamo il servizio che mi restituisce tutte le categorie di quel tipo
        this.axios.get(NAMESPACE + 'rest/categorie/tipo/' + flagTipo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        var res = response.data.message;
                        if (res.length > 0) {

                            var options = [];
                            for (var i = 0; i < res.length; i++) {
                                options.push({
                                    value: res[i].id,
                                    text: res[i].descrizione
                                });
                            }
                            
                            this.options_categorie = this.options_categorie.filter(function (element) {                       
                                return ctrlViscategoria(element.value);
                            });

                            this.options_categorie = options;

                        } else {
                            throw new Error("Errore categorie non trovate!");
                        }


                    } else {
                        throw new Error(response.data.message);
                    }


                } catch (e) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                appdettaglio.showerror = true;
                appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

        //creo la tendina visibilità
        var visibilità = new Visibilità();
        var options_vis = [];
        for (var i = 0; i < Object.keys(visibilità.getListaTipi()).length; i++) {
            options_vis.push({
                value: Object.keys(visibilità.getListaTipi())[i],
                text: visibilità.getTipoByFlag(Object.keys(visibilità.getListaTipi())[i])
            });
        }
        this.options_visibilità = options_vis;


    },
    mounted: function() { 
        
    }

}
</script>
